"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./HorizontalRule.scss");
var Join_1 = require("../../../helpers/Functions/Join");
var HorizontalRule = function (_a) {
    var centerWord = _a.centerWord, testId = _a.testId, onDark = _a.onDark, className = _a.className, ariaHidden = _a.ariaHidden;
    className = className ? className : "type-xs font-medium";
    var classes = onDark
        ? Join_1.join("on-dark", "color-ui-gray", className, styles.hrule)
        : Join_1.join("color-ui-black", className, styles.hrule);
    return (React.createElement("hr", { className: classes, "data-testid": testId, "aria-label": centerWord ? centerWord : undefined, "aria-hidden": ariaHidden ? ariaHidden : undefined }));
};
exports.default = HorizontalRule;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/HorizontalRule/HorizontalRule.js
// module id = 1772
// module chunks = 8